<div class="grid p-fluid flex-row-reverse dashboard-graph-grid">
  <div class="col-12 container">
    <h1>Gestione catalogo</h1>
    <!-- filters -->
    <div class="filters">
      <div class="grid mb-4">
        <div class="md:col-1 col-12">
          Finestra:
        </div>
        <div class="col-11">
          <p-toggle-button class="mr-2" onLabel="Pay 1 / SVOD 1" offLabel="Pay 1 / SVOD 1"
                           [ngModel]="filter().pay1"
                           (ngModelChange)="setModelProp('pay1', $event)"/>
          <p-toggle-button class="mr-2" onLabel="SVOD 2" offLabel="SVOD 2"
                           [ngModel]="filter().pay2"
                           (ngModelChange)="setModelProp('pay2', $event)"
          />
          <p-toggle-button class="mr-2" onLabel="SVOD 3" offLabel="SVOD 3"
                           [ngModel]="filter().pay3"
                           (ngModelChange)="setModelProp('pay3', $event)"
          />
          <p-toggle-button class="mr-2" onLabel="SVOD" offLabel="SVOD"
                           [ngModel]="filter().svod"
                           (ngModelChange)="setModelProp('svod', $event)"
          />
          <p-toggle-button class="mr-2" onLabel="FREE TV" offLabel="FREE TV"
                           [ngModel]="filter().freeTv"
                           (ngModelChange)="setModelProp('freeTv', $event)"
          />
          <p-toggle-button class="mr-2" onLabel="LIBRARY FREE TV" offLabel="LIBRARY FREE TV"
                           [ngModel]="filter().libraryFreeTv"
                           (ngModelChange)="setModelProp('libraryFreeTv', $event)"
          />
          <p-toggle-button class="mr-2" onLabel="LIBRARY FREE TV" offLabel="LIBRARY FREE TV"
                           [ngModel]="filter().librarySvod"
                           (ngModelChange)="setModelProp('librarySvod', $event)"
          />
        </div>
      </div>
      <div class="grid mb-3">
        <div class="md:col-1 col-12">
          Disponibilità:
        </div>
        <div class="col-11">
          <div>
            <p-toggle-button class="mr-2" onLabel="Riservato" offLabel="Riservato"
                             [ngModel]="filter().reserved"
                             (ngModelChange)="setModelProp('reserved', $event)"
            />
            <p-toggle-button class="mr-2" onLabel="Disponibile" offLabel="Disponibile"
                             [ngModel]="filter().available"
                             (ngModelChange)="setModelProp('available', $event)"
            />
          </div>
          <br>
          <div class="block">
            <app-checkbox label="Visualizza colonna disponibilità" [(model)]="showAvailabilityColumn"></app-checkbox>
          </div>
        </div>
      </div>
      <div class="grid mb-4">
        <div class="md:col-1 col-12">
          Intervallo:
        </div>
        <div class="col-11">
          <div class="inline-block mr-4">Dal</div>
          <div class="inline-block">
            <app-datetime [showTime]="false"
                          [model]="filter().timeFrom"
                          (modelChange)="setModelProp('timeFrom', $event)"

            />
          </div>
          <div class="inline-block mr-4 ml-4">al</div>

          <div class="inline-block">
            <app-datetime [showTime]="false"
                          [model]="filter().timeTo"
                          (modelChange)="setModelProp('timeTo', $event)"
            />
          </div>
        </div>
      </div>

      <div class="grid mb-4">
        <div class="flex flex-row col-10">
          <input pInputText type="search"
                 placeholder="Cerca film per titolo, regista, cast, info, premi o parola chiave"
                 [ngModel]="filter().searchText" (ngModelChange)="setModelProp('searchText', $event)"
                 (focusout)="load()">
        </div>
        <div class="flex flex-row col-2 justify-content-between">
          <p-button label="cerca" class="mr-2" (click)="load()"/>
          <p-button label="Aggiungi nuovo +" variant="outlined" (click)="createNew()"/>
        </div>
      </div>
    </div>
    <!-- table -->
    <p-table #table styleClass="p-datatable p-datatable-striped p-datatable-sm p-datatable-gridlines"
             [lazy]="true"
             [lazyLoadOnInit]="false"
             (onLazyLoad)="load($event)"
             [value]="movies.dataList"
             [rows]="filter().amount"
             [alwaysShowPaginator]="true"
             [rowsPerPageOptions]="[20, 50, 100, 150, 200]"
             [totalRecords]="movies.count"
             [paginator]="true"
             [rowHover]="true"
             [loading]="loading"
             [autoLayout]="true"
             responsiveLayout="stack"
    >
      <ng-template pTemplate="header">
        <tr class="left-aligned small-row">
          <th></th>
          <!-- <th [pSortableColumn]="movieStrigifier.title | pascalCase">-->
          <th>
            Titolo
            <!-- <p-sortIcon [field]="movieStrigifier.title | pascalCase"></p-sortIcon> -->
          </th>
          <th [pSortableColumn]="movieStrigifier.year | pascalCase">
            Anno
            <p-sortIcon [field]="movieStrigifier.year | pascalCase"></p-sortIcon>
          </th>
          <th [pSortableColumn]="movieStrigifier.ltr | pascalCase">
            LTR
            <p-sortIcon [field]="movieStrigifier.ltr | pascalCase"></p-sortIcon>
          </th>
          <th>Stato</th>
          <th>Finestra</th>
          <th>Disponibile</th>
          <th>Scadenza</th>
          <th>Modalità</th>
          @if (showAvailabilityColumn) {
            <th>Disponibilità</th>
          }
          <th>Visibilità</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        @let movie = obj(item);
        <tr class="highlight-bottom-border small-row">
          <td>
            <p-button icon="pi pi-pencil" variant="text" (click)="edit(movie.movieId)"/>
          </td>
          <td>
            <strong>
              {{ movie.itaDetails.title }}
            </strong>
          </td>
          <td>{{ movie.year }}</td>
          <td>{{ movie.ltr | date:'dd/MM/yyyy' }}</td>
          <td>{{ movie.movieAvailability[0].status }}</td>
          <td>{{ movie.movieAvailability[0].window | appWindowLabel }}</td>
          <td>{{ movie.movieAvailability[0].from | date:'dd/MM/yyyy' }}</td>
          <td>{{ movie.movieAvailability[0].expiration | date:'dd/MM/yyyy' }}</td>
          <td>{{ movie.movieAvailability[0].movieRights }}</td>
          @if (showAvailabilityColumn) {
            <td>
              @if (movie.movieAvailability[0].customerName) {
                <span class="badge badge-info">{{ movie.movieAvailability[0].customerName }}</span>
              } @else {
                <span class="badge badge-success">Disponibile</span>
              }
            </td>
          }
          <td>
            <app-dropdown [dropdownItems]="publishedItems"
                          [model]="movie.published.toString()"
                          (modelChange)="updatePublished(movie.movieId, $event === 'true')"
                          optionValue="value" optionLabel="label"
                          [showClear]="false" [showFilter]="false"
                          [createItemOnFly]="false"></app-dropdown>
          </td>
          <td>
            <!-- icon "v" to open the movie details -->
            <p-button [icon]="!openedMovies[movie.movieId] ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"
                      variant="text" (click)="toggleDetails(movie)"
                      [ariaLabel]="'Mostra dettagli per ' + movie.itaDetails.title"></p-button>
          </td>
        </tr>
        @if (openedMovies[movie.movieId]) {
          @for (subrow of movie.movieAvailability; track subrow.movieAvailabilityId) {
            @if (subrow != movie.movieAvailability[0]) {
              <tr class="small-row subrow" [@slideInOut]="openedMovies[movie.movieId] ? 'in' : 'out'">
                <td colspan="4"></td>
                <td class="colorize">
                  {{ subrow.status }}
                </td>
                <td class="colorize">
                  {{ subrow.window | appWindowLabel }}
                </td>
                <td class="colorize">
                  {{ subrow.from | date:'dd/MM/yyyy' }}
                </td>
                <td class="colorize">
                  {{ subrow.expiration | date:'dd/MM/yyyy' }}
                </td>
                <td class="colorize">
                  {{ subrow.movieRights }}
                </td>
                @if (showAvailabilityColumn) {
                  <td class="colorize">
                    @if (subrow.customerName) {
                      <span class="badge badge-info">{{ subrow.customerName }}</span>
                    } @else {
                      <span class="badge badge-success">Disponibile</span>
                    }
                  </td>
                }
                <td colspan="2">
                </td>
              </tr>
            }
          }
        }
      </ng-template>
    </p-table>
    <p-block-ui [target]="buttons" [blocked]="loading"/>
    <app-blockable-div #buttons>
      <div class="flex align-items-center justify-content-end mt-4 gap-3">
        <p class="m-0 flex align-items-center justify-content-center" style="height:100%;">Crea catalogo:</p>
        <p-button variant="outlined" severity="secondary" label="Scarica catalogo PDF" icon="pi pi-file-pdf"
                  (click)="downloadPdf()"/>
        <p-button variant="outlined" severity="secondary" label="Scarica elenco Excel" icon="pi pi-file-excel"
                  (click)="downloadExcel()"/>
      </div>
    </app-blockable-div>
  </div>
</div>
